module.exports = __webpack_public_path__ + "img/Rafael_1.47ed951f.png";